import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';
import { useFixedTitle } from '../Nav/hooks';
import { isGrounds } from '@src/public/utils/app';
import Draggable from 'react-draggable';

const IframeVideo = ({ liveData }) => {
    const IframeVideoRef = useRef(null);
    const IframeRef = useRef(null);
    const [iframeDistance, setIframeDistance] = useState(0);
    const [peopleNum, setPeopleNum] = useState(0);
    // const [liveStatus, setLiveStatus] = useState('直播中');
    const [isCloseFix, setIsCloseFix] = useState(false);
    let showFixed = useFixedTitle(iframeDistance);
    const handleFixedCloseClick = () => {
        setIsCloseFix(true);
    };

    const iframeVideoAutoPlay = () => {
        // alert('autoplay');
        IframeRef.current.contentWindow.postMessage({ type: 'autoPlay' }, '*');
    };

    const newAppPlay = () => {
        const creatFun = callback => {
            const funName = `__grounds_${Number(Math.floor(Math.random() * 10000000000)).toString(36)}`;

            window[funName] = msg => {
                callback(msg);
            };

            return funName;
        };
        const __Native = {
            intercall: (appCommand, callback) => {
                const funName = creatFun(callback);

                if (window.grounds) {
                    window.grounds[appCommand](funName);
                }
            },
        };

        __Native.intercall('deviceInfo', () => {
            iframeVideoAutoPlay();
        });
    };

    const autoplayHandler = () => {
        let isWxReady = false;
        let playerReady = false;
        const isWeixin = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;

        if (isWeixin) {
            // 微信
            if (typeof WeixinJSBridge == 'undefined') {
                document.addEventListener(
                    'WeixinJSBridgeReady',
                    () => {
                        isWxReady = true;
                        if (playerReady) {
                            iframeVideoAutoPlay();
                        }
                    },
                    false,
                );
            } else {
                isWxReady = true;
                if (playerReady) {
                    iframeVideoAutoPlay();
                }
            }
        }
        window.addEventListener('message', e => {
            // console.log(e.data, 'iframeData');
            if (e.data.type === 'init') {
                // 如果是自动播放需要自动播放
                playerReady = true;
                if (isWeixin) {
                    if (isWxReady) {
                        iframeVideoAutoPlay();
                    }
                } else if (window.grounds) {
                    newAppPlay();
                }
            }
            if (e.data.type === 'online' && e?.data?.data?.num) {
                setPeopleNum(e.data.data.num);
            }

            // 是否是画中画判断
            if (e.data.type === 'pipChange') {
                if (e.data.data) {
                    setIsCloseFix(true);
                } else {
                    setIsCloseFix(false);
                }
            }
        });
    };

    // 数字过万处理,超过一万显示为x.x万，不足一万显示原数字,小数点后一位不使用toFixed进行四舍五入
    const formatPeopleNum = num => {
        if (num >= 10000) {
            const decimal = Math.floor(num / 1000) / 10;

            return `${decimal.toString()}万`;
        } else {
            return num.toString();
        }
    };

    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        autoplayHandler();
    }, []);

    useEffect(() => {
        const IframeVideoTop = IframeVideoRef.current.getBoundingClientRect().top;
        const IframeVideoHeight = IframeVideoRef.current.getBoundingClientRect().height;

        setIframeDistance(IframeVideoTop + IframeVideoHeight);
    }, []);

    const handleDrag = (event, draggableData) => {};

    useEffect(
        () => {
            if (showFixed) {
                IframeRef.current.contentWindow.postMessage({ type: 'hideSkin' }, '*');
            } else {
                IframeRef.current.contentWindow.postMessage({ type: 'showSkin' }, '*');
            }
        },
        [showFixed],
    );

    let hostName = location.hostname.includes('10.20.') ? 'timeline.ifeng.com' : location.hostname;

    if (location.href.includes('videoDebug=1')) {
        hostName = 'timeline.ifeng.com';
    }

    return (
        <>
            <div className={styles.liveBox}>
                <div className={styles.iframeBox} ref={IframeVideoRef}>
                    <Draggable onDrag={handleDrag} handle={`.${styles.dragPop}`}>
                        <div
                            className={`${
                                showFixed &&
                                (liveData?.liveStatus === '1' || liveData?.liveStatus === '2') &&
                                !isCloseFix
                                    ? styles.IframeFix
                                    : styles.IframeVideo
                            }`}>
                            <iframe
                                allowFullScreen
                                ref={IframeRef}
                                scrolling="no"
                                frameBorder="0"
                                className={styles.iframe}
                                src={`https://${hostName}/loc/proxy/https/flive.ifeng.com/video/${
                                    liveData.liveId
                                }.html?from=timeline`}
                                // src={`https://timeline.ifeng.com/loc/proxy/https/flive.ifeng.com/video/${
                                //     liveData.liveId
                                // }.html?autoplay=1`}
                            />

                            {showFixed &&
                                !isCloseFix && (
                                    <>
                                        <div className={styles.dragPop} />
                                        <div className={styles.playerFixedClose} onClick={handleFixedCloseClick} />
                                    </>
                                )}
                        </div>
                    </Draggable>
                </div>
                {liveData?.title && <div className={styles.liveTitle}>{liveData.title}</div>}
                <div className={styles.liveInfo}>
                    <div className={styles.liveInfoUser}>
                        {liveData?.anchorAvatar && (
                            <img className={styles.liveInfoUserFace} src={liveData.anchorAvatar} />
                        )}
                        {liveData?.anchorName && <div className={styles.liveInfoUserName}>{liveData.anchorName}</div>}
                    </div>
                    {peopleNum !== 0 && (
                        <div className={styles.liveStatus}>
                            观看&nbsp;<span className={styles.liveLookNum}>{formatPeopleNum(peopleNum)}</span>
                        </div>
                    )}
                </div>
            </div>
            {isGrounds ? <div className={styles.liveInfoLine} /> : null}
        </>
    );
};

IframeVideo.propTypes = {
    liveData: PropTypes.object,
};

export default errorBoundary(IframeVideo);
